export default __webpack_public_path__ + "static/media/checked.7c3828a4.svg";